<template>
    <Breadcrumbs main="Learning" title="Learning List" />
    <div class="container-fluid">
        <div class="row">
            <learningList />
            <learningFilter />
        </div>
    </div>
</template>
<script lang="ts" setup>
import { defineAsyncComponent } from 'vue';
const learningList = defineAsyncComponent(() => import("@/components/theme/learning/list/learningList.vue"))
const learningFilter = defineAsyncComponent(() => import("@/components/commen/learningFilter.vue"))
</script>